// import { RecipeDetailPageFull } from '../recipe-detail/recipe-detail.full';
// import { Observable } from 'rxjs/Rx';
// mport { RecipeBoxDataGateway } from '../../providers/recipe-box-data-gateway';
// import { RecipeData } from '../../providers/recipe-data';
import { Component } from '@angular/core';
import { UserData } from '../../../../providers/user-data';
import { Events, NavController } from 'ionic-angular';
import { PageBaseFull } from '../../../../core/page-base.full';
import { AppSettings } from '../../../../config/app-settings';
import { CategoryBoxesCommon } from './category-boxes.common';

@Component({
	selector: 'category-boxes-full',
	templateUrl: 'category-boxes.full.html'
})
export class CategoryBoxesPageFull extends PageBaseFull {
	categoryId = '';
	category = {
		key: '',
		value: {}
	};
	userId = '';
	public recipeBoxData: any;
	public recipesList: any;
	public recipeCategories: any;
	public loader: any;
	public userRecipes = [];
	public localUserRecipes = [];
	public categoryUrlSlug = 'all';
	constructor(
		public nav: NavController,
		public userData: UserData,
		public settings: AppSettings,
		public events: Events,
		public common: CategoryBoxesCommon,
	) {
		super(settings, events, nav, userData);
		
	}
	
}


// WEBPACK FOOTER //
// ./src/modules/recipes/pages/category-boxes/category-boxes.full.ts